import online from './online'
import test from './test'

const config = (() => {
// eslint-disable-next-line no-undef
  return /\.biz/.test(location.host) ? test : online
})()

// eslint-disable-next-line no-undef
export default Object.assign({}, config)



// WEBPACK FOOTER //
// ./src/config/index.js